<template>
    <div class="map-editor-nav" :class="{ 'map-only-icon': !textShow }">
        <div class="map-title-bar" @click="exitEdit">
            <img class="map-title-logo" src="@/assets/images/icon/logo.png" alt="logo" draggable="false"
                oncontextmenu="return false;" />
            <img class="map-title-exit" src="@/assets/images/icon/exit.png" alt="返回" draggable="false"
                oncontextmenu="return false;" />
            <span class="map-caption">来讯品创</span>
        </div>
        <div class="map-editor-switch" @click="textShow = !textShow">
            <span class="map-editor-switch-icon icon-glyphicon-menu-hamburger"></span>
        </div>
        <EditorMenuBar :level="1" @nav-change="navChange" />
    </div>
</template>

<script>


import EditorMenuBar from '../common/EditorMenuBar.vue';

import { useRouter } from 'vue-router';

export default {
    name: 'MapEditorNav',
    components: {
        EditorMenuBar
    },
    data() {
        return {
            textShow: false,
            router: null,
        }
    },

    mounted() {
        this.router = useRouter();
    },
    methods: {
        exitEdit() {
            this.router.push({ path: '/map/list' });
        },
        navChange(data) {

            this.$emit('nav-change', data);
        },
    }
}

</script>

<style scoped>
.map-editor-nav {
    height: 100%;
    background-color: #1b2c3e;

    width: 106px;
    box-shadow: 1px 3px 5px #e0e0e0;
    color: #b2bcc5;



    -webkit-transition: all 0.15s ease-in-out;
    -moz-transition: all 0.15s ease-in-out;
    -o-transition: all 0.15s ease-in-out;
    transition: all 0.15s ease-in-out;
}

.map-title-bar {
    height: 46px;
    line-height: 46px;
    cursor: pointer;
    top: 0;
    z-index: 0;
    white-space: nowrap;
    background-color: #1b2d3e;
    border-bottom: 1px solid #354e66;
    transition: all 0.15s ease-in-out;
    vertical-align: middle;
}

.map-caption {
    vertical-align: middle;
    font-size: 12px;
    margin-left: 4px;
    height: 46px;
    line-height: 46px;

}

.map-title-exit {
    width: 18px;
    display: none;
    margin-left: 15px;
}

.map-title-logo {
    width: 18px;
    margin-left: 15px;
}

.map-title-bar:hover .map-title-exit {
    display: inline-block;

}

.map-title-bar:hover .map-title-logo {
    display: none;
}

.map-editor-switch-icon {
    color: #fff;
    font-size: 12px;
    position: relative;
    top: 2px;
    transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -o-transform: rotate(90deg);

}

.map-editor-switch {
    position: absolute;
    top: 46px;
    height: 20px;
    line-height: 20px;
    min-width: 50px;
    width: 106px;
    font-size: 12px;
    text-align: center;
    z-index: 10;
    border-bottom: 1px solid #354e66;
    -webkit-transition: all 0.15s ease-in-out;
    -moz-transition: all 0.15s ease-in-out;
    -o-transition: all 0.15s ease-in-out;
    transition: all 0.15s ease-in-out;
    cursor: pointer;
}

.map-editor-switch:hover .map-editor-switch-icon {
    color: #0095ff !important;
}
</style>